import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import {HttpClient,HttpHeaders} from "@angular/common/http";

import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class PreferenceService {

  private APIURL = environment.baseURL;

  constructor(public httpClient: HttpClient,private authService:AuthService) { this.httpClient = httpClient; }

  getByUser(): Observable<any> {
    return this.httpClient.get(`${this.APIURL}/preferences/user/${JSON.parse(localStorage.getItem("me")).user.id}`)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  update(param): Observable<any> {
    return this.httpClient.put(`${this.APIURL}/preferences/${param.id}`,param.data)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  add(param): Observable<any> {
    return this.httpClient.post(`${this.APIURL}/preferences`,param)
    .pipe(
      catchError((err => {
        return this.handleError(err);
      })
    ));
  }

  private handleError(error: any): Observable<any> {
    return throwError(error);
  }
}
